import i18n from "@/i18n"

const synchronizationFormats = [
  {
    value: "XML_YML",
    label: i18n.t("synchronization.yandex_format")
  },
  {
    value: "XML_HOTLINE",
    label: i18n.t("synchronization.hotline_format")
  }
]

export default synchronizationFormats

export const DEFAULT_SYNCHONIZATION_FORMAT = "XML_YML"
